import React from 'react';

import {useI18n} from '@udemy/i18n';

import {CoursesCarouselList} from '../../courses-carousel-list/courses-carousel-list.react-component';
import sharedStyles from '../free-resources-section.module.less';
import {
    UseCoursesByIdsResult,
    withFreeResourcesCoursesData,
} from '../with-free-resources-courses-data.react-component';

const MAX_COURSES_PER_ROW = 4;

export type FreeResourcesCoursesSectionProps = {
    maxCoursesPerRow?: number;
};

type FreeResourcesCoursesSectionInnerProps = FreeResourcesCoursesSectionProps & {
    coursesResult: UseCoursesByIdsResult;
};

const FreeResourcesCoursesSectionComponent = ({
    coursesResult,
    maxCoursesPerRow = MAX_COURSES_PER_ROW,
}: FreeResourcesCoursesSectionInnerProps) => {
    const {gettext} = useI18n();
    const {count, isLoading, courses} = coursesResult;

    return (
        <div className={sharedStyles['resources-container']}>
            <h4 className="ud-heading-xl">{gettext('Make AI work for you')}</h4>
            <div className={sharedStyles['resources-list-wrapper']}>
                <CoursesCarouselList
                    courses={courses}
                    totalCount={count}
                    isLoading={isLoading}
                    maxCoursesPerRow={maxCoursesPerRow}
                />
            </div>
        </div>
    );
};

export const FreeResourcesCoursesSection = withFreeResourcesCoursesData(
    FreeResourcesCoursesSectionComponent,
);
